import { nanoid } from "nanoid";
const getId = () => {
    return nanoid();
};
export default getId;
